import type { SubscribePlanChangeUpgradeGet200UpgradeInfo } from './subscribePlanChangeUpgradeGet200UpgradeInfo';

export type SubscribePlanChangeUpgradeGet200 = {
  message?: string;
  success: boolean;
  upgradeInfo?: SubscribePlanChangeUpgradeGet200UpgradeInfo;
};
